import { EnvironmentSpecific } from "./environment.interface";

const website = "https://intractive.app";

export const intractive: EnvironmentSpecific = {
  identifier: "app.intractive",
  hasAuthentication: false,
  iosAppstoreId: "1493164093",
  calendarColor: "blue",
  type: "business",
  environmentName: "intractive",
  website,
  contact: `${website}/contact/`,
  name: "Intractive",
  youtube: undefined,
  instagram: "https://www.instagram.com/intractive/",
  facebook: undefined,
  linkedin: "https://www.linkedin.com/company/intractiveplatform/",
  terms: `${website}/terms-of-use/`,
  privacy: `${website}/privacy-policy/`,
  oneSignalAppId: "261107eb-b93c-4dad-a2cd-7a234cd92d92",
};
